// Webpack
// import "bootstrap";
// import "jquery-match-height";
import MicroModal from "micromodal";
// import Swiper from 'swiper/bundle';
// import objectFitImages from "object-fit-images";

const bodyScrollLock = require("body-scroll-lock");
const disableBodyScroll = bodyScrollLock.disableBodyScroll;
const enableBodyScroll = bodyScrollLock.enableBodyScroll;

MicroModal.init();

const setHeaderPadding = () => {
  if (window.outerWidth < 992) {
    let headerHeight = document.getElementById("masthead").offsetHeight;
    document.body.style.paddingTop = `${headerHeight}px`;
  } else {
    document.body.style.paddingTop = `0px`;
  }
};

window.addEventListener("DOMContentLoaded", () => {
  setHeaderPadding();
  window.addEventListener("resize", setHeaderPadding);

  // Mobile navigation
  const mobileNavigation = document.getElementById("mobile-navigation");
  const headerToggleBtn = document.getElementsByClassName(
    "header-toggle-btn"
  )[0];

  const closeNavigation = () => {
    MicroModal.close("mobile-navigation");
    enableBodyScroll(mobileNavigation);
  };

  const openNavigation = () => {
    MicroModal.show("mobile-navigation", {
      disableScroll: false,
      disableFocus: true,
      awaitCloseAnimation: true,
    });
    disableBodyScroll(mobileNavigation);
    // ヘッダーの高さを取得
    let headerHeight = document.getElementById("masthead").offsetHeight;
    mobileNavigation.style.top = `${headerHeight}px`;
  };

  headerToggleBtn.addEventListener("click", () => {
    headerToggleBtn.classList.toggle("is-active");
    let headerToggleBtnIcon = document.querySelector(
      ".header-toggle-btn__icon"
    );

    headerToggleBtnIcon.classList.toggle("ri-menu-line");
    headerToggleBtnIcon.classList.toggle("ri-close-line");

    if (mobileNavigation.classList.contains("is-open")) {
      closeNavigation();
    } else {
      openNavigation();
    }
  });
});

// Swiper.js
const mainVisualSlider = new Swiper(".main-visual-slider", {
  loop: true,
  speed: 800,
  autoplay: {
    delay: 4000,
  },
  slidesPerView: 1,
  centeredSlides: true,
  spaceBetween: 24,
  pagination: {
    el: ".main-visual-pagination",
  },
  navigation: {
    nextEl: ".main-visual-button-next",
    prevEl: ".main-visual-button-prev",
  },
  breakpointsInverse: true,
  breakpoints: {
    992: {
      slidesPerView: 3.4,
    },
  },
});

const recommendedCategorySlider = new Swiper('.recommended-category-slider', {
  loop: false,
  speed: 800,
  slidesPerView: 1.5,
  centeredSlides: true,
  spaceBetween: 16,
  navigation: {
    nextEl: '.recommended-category-button-next',
    prevEl: '.recommended-category-button-prev',
  },
  breakpointsInverse: true,
  breakpoints: {
    992: {
      slidesOffsetBefore: 24,
      slidesPerView: 3.5,
      centeredSlides: false,
    },
  },
});